<p-panel>
    @if (isReactiveFormReady) {
        <app-reactive-form-builder
            #builderRef
            (stableValueChanges)="stableValueChanges($event)"
            (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
            (goBack)="goBack()"
            (afterSend)="onAfterSend()"
            [form]="form.formFields"
            [serverUrl]="form.env.serverUrl"
            [previousData]="initialPreviousData"
            [id]="reactiveFormRecordId"
            [request]="request"
            [getRequest]="getRequest"
            [undoEnabled]="undoEnabled">
        </app-reactive-form-builder>
    } @else if (reactiveFormLoadingError) {
        <div class="alert alert-danger mb-0" role="alert">
            {{ reactiveFormLoadingError }}
        </div>
    } @else {
        <div class="alert alert-info mb-0" role="status" aria-live="polite">
            {{ reactiveFormLoadingLabel }}
        </div>
    }
</p-panel>
